import { Route } from './Route';

export interface GuideMenuItem {
  title: string;
  description: string;
  route: Route;
  icon: string;
}

export const GuideMenuItems: GuideMenuItem[] = [
  {
    title: '配送・送料について',
    description: '送料やお届け日数についてのご案内。',
    route: { route: 'shipping' },
    icon: 'Shipping',
  },
  {
    title: 'お支払いについて',
    description: 'クレジットカード等、各種お支払い方法のご案内。',
    route: { route: 'payment' },
    icon: 'Card',
  },
  {
    title: '返品・交換について',
    description: '返品・交換についてのご案内。',
    route: { route: 'refunds' },
    icon: 'Order',
  },
  {
    title: 'オーダー商品について',
    description: '名入れやプリント等、カスタマイズ商品のご注文方法。',
    route: { route: 'ordermade' },
    icon: 'Order',
  },
  {
    title: 'よくある質問',
    description: 'お問い合わせの多い質問を掲載。不明点は気軽にお問い合わせを。',
    route: { route: 'questions' },
    icon: 'FAQ',
  },
];
